var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"overflow":"hidden","border":"none","margin":"0","margin-top":"0"},attrs:{"src":_vm.modalData,"id":"iframe-content","width":_vm.iframeWidth,"height":_vm.iframeHeight}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a7f8f28","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modals/modals/userProfile/deposit/DepositResponseModal.vue
// module id = 2544
// module chunks = 0